// extracted by mini-css-extract-plugin
module.exports = {"add-box-button":"AddBoxButton_add-box-button__eWARH"};